<template>
  <div class="user">
    <el-card shadow="never">
      <div class="header-flex">
        <h1>用户列表</h1>
        <div class="input-flex">
          <el-input
            placeholder="请输入搜索内容"
            v-model.lazy="keyword"
            clearable
            class="input"
          ></el-input>
        </div>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%"
        :max-height="scrollHeight"
      >
        <el-table-column fixed prop="id" label="ID"></el-table-column>
        <el-table-column prop="nick_name" label="用户昵称"></el-table-column>
        <el-table-column prop="avatar_url" label="用户头像">
          <template slot-scope="scope">
            <el-image
              class="user-avatar"
              :src="scope.row.avatar_url"
              :preview-src-list="previewList"
              @click="previewImg(scope.row.avatar_url)"
            />
          </template>
        </el-table-column>
        <el-table-column prop="add_time" label="访问时间"></el-table-column>
        <el-table-column prop="gender" label="性别">
          <template slot-scope="scope">
            <div>{{ scope.row.gender == 1 ? "男" : "女" }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="country" label="国家"></el-table-column>
        <el-table-column prop="province" label="省份"></el-table-column>
        <el-table-column prop="city" label="城市"></el-table-column>
        <el-table-column prop="language" label="语言"></el-table-column>
        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button
              @click="deleteRow(scope.$index, scope.row, tableData)"
              type="danger"
              size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import debounce from "@/utils/debounce";
import { visitorList, delVisitorLog } from "@/api/viewer";
export default {
  name: "user",
  data() {
    return {
      tableData: [],
      scrollHeight: 100,
      total: 0,
      currentPage: 1,
      pageSize: 10,
      keyword: "",
      previewList: [],
    };
  },
  watch: {
    /**
     * 搜索用户
     * @param {string} key - 搜索关键词
     */
    keyword() {
      debounce(() => {
        this.$store.dispatch("fullscreenLoading", true);
        this.getData({
          keyword: this.keyword,
          page: 1,
          limit: this.pageSize,
        });
      }, 800);
    },
  },
  created() {
    this.$store.dispatch("fullscreenLoading", true);
  },
  mounted() {
    this.$nextTick(() => {
      this.scrollHeight = document.body.clientHeight - 290;
    });
    this.getData();
  },
  methods: {
    /**
     * 数据列表
     */
    getData() {
      visitorList({
        keyword: this.keyword,
        page: this.currentPage,
        limit: this.pageSize,
      }).then((res) => {
        this.total = res.data.total;
        this.tableData = res.data.list;
        this.$store.dispatch("fullscreenLoading", false);
      });
    },
    /**
     * 删除用户记录
     * @param {number} index - 下标
     * @param {object} row - 列表项
     * @param {array} rows - 列表
     */
    deleteRow(index, row, rows) {
      this.$confirm("是否要删除当前用户?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delVisitorLog({
          id: row.id,
        }).then(() => {
          this.$message.success("删除成功!");
          rows.splice(index, 1);
          this.getData();
        });
      });
    },
    /**
     * 查看图片
     * @param {string} url - 图片地址
     */
    previewImg(url) {
      this.previewList = [url];
    },
    /**
     * 改变单页数量
     * @param {number} val - 单页数量值
     */
    handleSizeChange(val) {
      this.$store.dispatch("fullscreenLoading", true);
      this.pageSize = val;
      this.getData();
    },
    /**
     * 切换页面
     * @param {number} val - 选中页面
     */
    handleCurrentChange(val) {
      this.$store.dispatch("fullscreenLoading", true);
      this.currentPage = val;
      this.getData();
    },
  },
};
</script>

<style scoped src="./style/index.css"></style>
<style scoped></style>
